var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80516 3.82783L13.1869 2.06368L20.6017 3.85377M5.80516 3.82783L1.8699 8.54088M5.80516 3.82783L13.2449 5.26336M5.80516 3.82783L8.39828 10.5039M20.6017 3.85377L13.2531 5.26336M20.6017 3.85377L18.0334 10.5385M20.6017 3.85377V3.83648M1.8699 8.54088L8.00061 16.3325M1.8699 8.54088L8.39828 10.5039M20.5934 3.85377L24.5287 8.59277L21.861 11.9914M20.6597 13.5393L13.2449 23M18.0334 10.5385L24.537 8.60141M18.0334 10.5385L13.2449 5.26336M18.0334 10.5385L8.39828 10.5039M13.2449 22.9914L10.0221 18.9009M13.2449 22.9914L18.0334 10.5299M13.2449 22.9914L8.39828 10.5039M13.2449 5.26336L8.39828 10.5126M25.7051 1V1.71777M25.7051 5.07311V5.79088M28 3.39544H27.3124M24.0979 3.39544H23.4102M3.29488 15.6148V16.3325M3.29488 19.6965V20.4143M5.58975 18.0102H4.90212M1.68763 18.0102H1",
    stroke: "white",
    strokeOpacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamante);
export default __webpack_public_path__ + "static/media/diamante.3586df2a9328566a8ec5a82ef38ff4d8.svg";
export { ForwardRef as ReactComponent };